import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from '@/hooks/useAuth'
import Layout from '@/components/layout/Layout'
import ProtectedRoute from './ProtectedRoute'
import AuthDebug from '@/components/AuthDebug'

// Public pages
import Home from './(public)/home/Home'
import Servicios from './(public)/servicios/Servicios'
import InteligenciaArtificial from './(public)/servicios/inteligencia-artificial/InteligenciaArtificial'
import DesarrolloWeb from './(public)/servicios/desarrollo-web/DesarrolloWeb'
import Automatizacion from './(public)/servicios/automatizacion/Automatizacion'
import SolucionesCloud from './(public)/servicios/cloud/SolucionesCloud'
import Ciberseguridad from './(public)/servicios/ciberseguridad/Ciberseguridad'
import Casos from './(public)/casos/Casos'
import Blog from './(public)/blog/Blog'
import BlogPost from './(public)/blog/BlogPost'
import Equipo from './(public)/equipo/Equipo'
import Contacto from './(public)/contacto/Contacto'

// Admin pages
import Login from './Login'
import AdminDashboard from './(admin)/dashboard/Dashboard'
import AdminServicios from './(admin)/servicios/AdminServicios'
import AdminCasos from './(admin)/casos/AdminCasos'
import AdminBlog from './(admin)/blog/AdminBlog'
import AdminEquipo from './(admin)/equipo/AdminEquipo'
import AdminAjustes from './(admin)/ajustes/Ajustes'

function App() {
  return (
    <AuthProvider>
      <div className="App">
        {/* Debug component - remove in production */}
        <AuthDebug />
        
        {/* Neural network background */}
        <div className="neural-bg" />
        
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="servicios" element={<Servicios />} />
            <Route path="servicios/inteligencia-artificial" element={<InteligenciaArtificial />} />
            <Route path="servicios/desarrollo-web" element={<DesarrolloWeb />} />
            <Route path="servicios/automatizacion" element={<Automatizacion />} />
            <Route path="servicios/cloud" element={<SolucionesCloud />} />
            <Route path="servicios/ciberseguridad" element={<Ciberseguridad />} />
            <Route path="casos" element={<Casos />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blog/:slug" element={<BlogPost />} />
            <Route path="equipo" element={<Equipo />} />
            <Route path="contacto" element={<Contacto />} />
          </Route>

          {/* Auth Route */}
          <Route path="/login" element={<Login />} />

          {/* Protected Admin Routes */}
          <Route path="/admin" element={<ProtectedRoute />}>
            <Route index element={<AdminDashboard />} />
            <Route path="servicios" element={<AdminServicios />} />
            <Route path="casos" element={<AdminCasos />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="equipo" element={<AdminEquipo />} />
            <Route path="ajustes" element={<AdminAjustes />} />
          </Route>

          {/* 404 Route */}
          <Route path="*" element={
            <div className="min-h-screen flex items-center justify-center bg-dark">
              <div className="text-center">
                <h1 className="text-6xl font-bold text-gradient mb-4">404</h1>
                <p className="text-gray-400 mb-8">Página no encontrada</p>
                <a 
                  href="/" 
                  className="btn-hover bg-primary text-dark px-6 py-3 rounded-lg font-semibold"
                >
                  Volver al inicio
                </a>
              </div>
            </div>
          } />
        </Routes>
      </div>
    </AuthProvider>
  )
}

export default App
